export default "__VITE_ASSET__DvOFGGkl__"